import {useState} from "react";
import {Form, Icon, Input} from "semantic-ui-react";
import {calclastdigit, checksum} from "../../utils/checkSumEAN";

interface Props {
  label: string;
  error: any;
  ean?: string;
  name: string;
  onInputChange: (e: any) => void;
}

export const InputEAN = ({label, error, ean, name, onInputChange}: Props) => {
  const [suggestedDigit, setSuggestedDigit] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const handleInputChange = (e: any) => {
    if (e.target.value.length === 7 || e.target.value.length === 12 || e.target.value.length === 13) {
      const lastDigit = calclastdigit(e.target.value);
      setSuggestedDigit(lastDigit);
    } else {
      setSuggestedDigit("");
    }

    onInputChange(e);
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
        e.preventDefault();
      if (suggestedDigit && ean && (ean.length === 7 || ean.length === 12 || ean.length === 13)) {
        const updatedValue = ean + suggestedDigit;
        const updatedEvent = {target: {name, value: updatedValue}};
        onInputChange(updatedEvent);

        const lastDigit = calclastdigit(updatedEvent.target.value);
        setSuggestedDigit(lastDigit);
      }
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const renderLabelContent = () => {
    if (!ean || ean === "") return {basic: true, content: ""};

    if (isFocused && suggestedDigit !== "-" && suggestedDigit !== "") {
      return {basic: true, content: <span style={{color: "grey", padding: 1}}>{suggestedDigit}</span>};
    } else {
      if (error || (ean.length !== 14 && ean.length !== 8 && ean.length !== 13) || !checksum(ean)) {
        return {basic: true, content: <Icon name="close" color="red" size="small" style={{padding: 0, margin: 0}} />};
      } else {
        return {basic: true, content: <Icon name="check" color="green" size="small" style={{padding: 0, margin: 0}} />};
      }
    }
  };

  return (
    <Form.Field>
      <label>{label}</label>
      <Form.Input
        error={error ? {content: error} : false}
        input={
          <Input
            placeholder="EAN14"
            maxLength={14}
            name={name}
            value={ean || ""}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            labelPosition="right"
            label={renderLabelContent()}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
        }
      />
    </Form.Field>
  );
};
